import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/user-management/parent"

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL (values)}`);
}

export const Edit = async (values,id) => {
    return await axiosInstance(options).put(`${path}/${id}`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/${values}`)
}

export const BulkDelete = async (values) => {
    return await axiosInstance(options).post(`${path}/bulk-delete`, values);
}

export const profileVerify = async (values,id) => {
    return await axiosInstance(options).put(`${path}/profile-verified/${id}`,values)
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Status = async (values,id) => {
    return await axiosInstance(options).patch(`${path}/status/${id}`, values)
}

//http://localhost:5000/webservice/api/v1/admin/user-management/parent/link-child/b6b59405-3a62-4e56-…
export const inChild  = async (id) => {
    return await axiosInstance(options).get(`${path}/link-child/${id}`);
}

